<template>
    <a-drawer
      :title="'监考信息-'+actionName"
      placement="right"
      :closable="false"
      :visible="visible"
      @close="onClose"
      width="30%">
        <div class="input-box">
            <p>系别：</p>
            <a-select
                class="input"
                show-search
                :filter-option="filterOption"
                @change="handSearch"
                v-model="info.orgCode"
                allowClear
                :disabled="actionName=='查看'">
                <a-select-option v-for="(item,index) in xbArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
        </div>
        <div class="input-box">
            <p>教师名：</p>
            <a-select
                :disabled="actionName=='查看'"
                class="input" 
                allowClear
                show-search
                :filter-option="filterOption"
                v-model="info.teacherId"
                @change="teacherSelect"
                option-label-prop="label">
                <a-select-option v-for="(item,index) in jsArr" :key="index" :value="item.teacherId" :label="item.teacherName">{{item.teacherId}}-{{item.teacherName}}</a-select-option>
            </a-select>
        </div>
        <div class="input-box">
            <p>学年：</p>
            <a-date-picker
                allowClear
                class="input"
                mode="year"
                format='YYYY'
                v-model="year" 
                :open='yearShowOne' 
                @openChange="openChangeOne"
                @panelChange="panelChangeOne">
                <a-input  v-model="info.schoolYear" :disabled="actionName=='查看'"/>
            </a-date-picker>
        </div>
        <div class="input-box">
            <p>秋季监考次数：</p>
            <a-input-number class="input" :disabled="actionName=='查看'" v-model="info.autumnCount" />
        </div>
        
        <div class="input-box" v-if="!hideWinterExamCount">
            <p>冬季监考次数：</p>
            <a-input-number class="input" :disabled="actionName=='查看'" v-model="info.winterCount" />
        </div>
        <div class="input-box">
            <p>春季监考次数：</p>
            <a-input-number class="input" :disabled="actionName=='查看'" v-model="info.springCount" />
        </div>

        <div class="btn-box">
            <a-button type="primary" @click="sub" v-if="actionName!='查看'">提交</a-button>
            <a-button @click="onClose">取消</a-button>
        </div>
    </a-drawer>

</template>

<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { add,update,info } from '@/baseAPI/undergraduate/culture/invigilator'
    import { getTeacher } from '@/baseAPI/facultyTeacher'
    import { getSchoolYear } from '@/baseAPI/util'
    export default {
        name: '',
        components: {
        },
        computed: {
            hideWinterExamCount() {
                if (this.info.schoolYear) {
                    this.info.winterCount = '';
                    return this.info.schoolYear.split('-')[0] >= 2025;
                }
                return false;
            }
        },
        data() {
            return {
                actionName:'',
                visible:false,
                id:'',
                info:{
                    orgCode:null,
                    orgName:null,
                    teacherId:null,
                    teacherName:null,
                    schoolYear:null,
                    springCount:null,
                    autumnCount:null,
                    winterCount:null,
                    totalCount:null
                },
                jsArr:[],
                xbArr:[],
                xnArr:[],
                year:'',
                yearShowOne:false,
            }
        },
        mounted () {
            this.info.schoolYear=getSchoolYear()+'-'+(getSchoolYear()+1)
            getTeacher().then(res=>{
                this.jsArr=res.data;
            })
        },
        methods:{
            // 弹出日历和关闭日历的回调
            openChangeOne(status) {
                    if (status){
                        this.yearShowOne =  true
                    }
                },
            // 得到年份选择器的值
            panelChangeOne(value) {
                this.year=this.getTimeStr(value._d,'yyyy')
                this.info.schoolYear=this.year+'-'+(this.year-0+1);
                this.yearShowOne = false;
            },
            getInfo(){
                getDicts({dataCode:'XY',status:true}).then(res=>{
                    this.xbArr=res.data.dicts;
                    this.info.orgCode=res.data.defaultValue[0]
                })
                if(this.actionName!='新增'){
                    info(this.id).then(res=>{
                        this.info=res.data;
                        this.teacherSearch(this.info.teacherId)
                    })
                }
            },
            showDrawer(name,id){
                this.id=id;
                this.actionName=name;
                this.getInfo();
                this.visible=true;
            },
            onClose() {
                this.info={
                    orgCode:null,
                    orgName:null,
                    teacherId:null,
                    teacherName:null,
                    schoolYear:null,
                    springCount:null,
                    autumnCount:null,
                    winterCount:null,
                    totalCount:null
                };
               this.visible = false;
                this.$parent.fetch()
            },
            handSearch(value){
                if(value!=''){
                    this.info.orgCode=value
                    this.info.orgName=this.xbArr.filter(item => item.dataCode == value)[0].dataName;
                }
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            teacherSelect(){
                for(let i=0;i<this.jsArr.length;i++){
                    if(this.jsArr[i].teacherId==this.info.teacherId){
                        this.info.teacherId=this.jsArr[i].teacherId
                        this.info.teacherName=this.jsArr[i].teacherName
                    }
                }
            },
            sub(){
                var isSub=true;
                // var arr=['approvalStatus']
                // for(let key in this.info){
                //     if(arr.indexOf(key)<0){
                //         if(this.info[key]==null||this.info[key]===''){
                //             isSub=false;
                //             break;
                //         }
                //     }
                // }
                if(isSub){
                    this.info.totalCount=this.info.springCount+this.info.autumnCount+this.info.winterCount
                    if(this.actionName=='新增'){
                        add(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'新增监考信息成功',
                                });
                                this.onClose()
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }else{
                        update(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'修改监考信息成功',
                                });
                                this.onClose()
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }
                }else{
                    this.$notification['warning']({
                        message: '警告',
                        description:'请填写完整！',
                    });
                }
            },        }
    }
</script>

<style scoped>
    .ant-drawer >>> .ant-drawer-header{
        background-color: #245086;
        border-radius: 0;
    }
    .ant-drawer >>> .ant-drawer-title{
        color: #fff;
        font-weight: bold;
        letter-spacing: 1px;
        font-size: 1.1rem;
    }
    .input-box{
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
        position: relative;
    }
    .input-box p{
        width: 8rem;
        text-align: right;
    }
    .input-box .input{
        width: calc(100% - 8rem);
    }
    .input-box .tips{
        width: calc(100% - 8rem);
        position: absolute;
        right: 0;
        top: 100%;
        font-size: 13px;
        line-height: 20px;
        color: #1890ff;
    }
    .btn-box{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        text-align: right;
        padding-bottom: 1rem;
        background-color: #fff;
    }
    .btn-box .ant-btn{
        margin-right: 2rem;
    }
    .ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    }

</style>
